import "pages/RestrictedAccessPage.scss";
import Button from "core/buttons/button/Button";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { SCOPES } from "constants/constants";
import { getDefaultRoutes, Scopes } from "utils/helper";
import { useEffect } from "react";
import { useUserContext } from "api/user/UserProvider";

const NotFoundPage = ({ userScope }) => {
  const { setUserScope, userRoleList } = useUserContext();

  const defaultRoute = getDefaultRoutes(userRoleList);

  useEffect(() => {
    if (!_.includes(Scopes, userScope)) {
      setUserScope(SCOPES.PERSO);
    }
  }, []);

  return (
    <div className="unauthorized-page">
      <div className="image image-not-found" />
      <div className="content">
        <div className="error-number">
          <FormattedMessage id="error" defaultMessage="Erreur" /> 404
        </div>
        <div className="error-type text-uppercase">
          <FormattedMessage id="forbidden" defaultMessage="INTERDIT" />
        </div>
        <div className="error-message">
          <FormattedMessage
            id="error_message"
            defaultMessage="Merci de contacter l'administrateur du serveur en lui spécifiant l’heure et les circonstances de l’erreur."
          />
        </div>
        <Button
          color="btn-standard gray-700"
          type="link"
          to={`/${userScope}${defaultRoute}`}
        >
          <FormattedMessage
            id="button_back_dash"
            defaultMessage="Retourner sur le dashboard"
          />
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
